import { Injectable, EventEmitter } from '@angular/core';
import { HttpService, IResponseLower, IResponse } from '../../../shared/cardholders-core/services/http-service.service';
import { AppConfigsService } from '../../../config/app-configs.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IContents } from '../interfaces/contents.interface';
import { ITransactionDataResponse } from '../interfaces/transaction-data-response.interface';
import { IFairCreditResult } from '../interfaces/fair-credit-rusult.interface';
import { ICreditDataForFairLawSpreadTransactionRequest } from '../interfaces/fair-credit-request.interface';
import { ExecuteSpreadTransaction } from '../interfaces/autorizations-for-credit-request.interface';
import { tap } from 'rxjs/operators';
import { ISpreadTransactionT } from '../../transactions/transaction-details/models/ISpreadTransaction';
import { ISpreadResult } from '../../transactions/transaction-details/models/IDeal';
import { IExecuteSpreadTransactionResponse, TransactionT } from '../interfaces/IexecuteSpreadTransaction.interface';
import { UiHelperService } from 'ClientApp/app/shared/cardholders-core/services/ui-helper.service';
import { IRegisterCreditProductsResult } from '../interfaces/register-credit-products-result.interface';
import { ISpreadTransactionInsertNewAgreementRequest } from '../interfaces/insert-agreement-request-interface';
import { Benefits } from '../interfaces/benefit.interface';
@Injectable()
export class SpreadTransactionService {
    showLoader: EventEmitter<boolean> = new EventEmitter<boolean>();
    contents: IContents;
    transactionData: ITransactionDataResponse;
    getContentsFinished = false;
    getAuthorizationDataFinished = false;
    showInterestMediation: boolean;
    data: string;
    isRegisterToAuthorizationSuccess: boolean;
    numOfPayments: number;
    fairCreditResult: IFairCreditResult;
    errorPageShowBtnLink = false;
    next = 'main';
    rc = 0;
    otherTransaction: TransactionT[];
    crmId: number;
    registerCreditProductsResult: IRegisterCreditProductsResult;
    isExecuteWithMahatz = false;
    isSSO = false;
    isFromNewSpreadTransaction = false;
    isFromNewSpreadTransactionWebView = false;
    paymentsValue: number;
    fundReturnDate: Date;
    recommendationId: string;
    benefit: Benefits;

    constructor(
        private httpSvc: HttpService,
        private appConfigsService: AppConfigsService,
        private uiHelper: UiHelperService
    ) {}

    getContents(): Observable<IResponseLower<IContents>> {
        this.showLoader.emit(true);
        return this.httpSvc
            .getLower<IContents>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/getContents`,
                null
            )
            .pipe(
                tap(res => {
                    this.contents = res.result;
                    this.getContentsFinished = true;
                    if (this.getAuthorizationDataFinished) {
                        this.showLoader.emit(false);
                    }
                })
            );
    }

    getTransactionData(): Observable<IResponseLower<ITransactionDataResponse>> {
        // if (this.transactionData) {
        //     return new BehaviorSubject<IResponseLower<ITransactionDataResponse>>({
        //         result: this.transactionData,
        //         returnCode: 0,
        //         rcDesc: '',
        //         correlationId: ''
        //     }).asObservable();
        // }
        this.showLoader.emit(true);
        return this.httpSvc
            .postLower<ITransactionDataResponse>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/getAuthorizationData`,
                null
            )
            .pipe(
                tap((res: IResponseLower<ITransactionDataResponse>) => {
                    this.isFromNewSpreadTransaction = res.result?.isFromNewSpreadTransaction ?? false;
                    if (res.returnCode === 0) {
                        this.transactionData = res.result;
                    } else {
                        this.rc = res.returnCode;
                    }
                    this.getAuthorizationDataFinished = true;
                        this.showLoader.emit(false);
                })
            );
    }
    checkSpreading(data: ISpreadTransactionT): Observable<IResponseLower<ISpreadResult>> {
        return this.httpSvc
            .postLower(`${this.appConfigsService.appConfigs.apiUrl}/registered/transactionDetails/CheckSpreading`, data)
            .pipe(
                tap((res: IResponseLower<ISpreadResult>) => {
                    if (res.returnCode !== 0) {
                        this.rc = res.returnCode;
                        this.showLoader.emit(false);
                    }
                })
            );
    }
    checkSpreadingSSO(): Observable<IResponseLower<ISpreadResult>> {
        return this.httpSvc
            .postLower(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/transactionDetails/CheckSpreadingSSO`,
                null
            )
            .pipe(
                tap((res: IResponseLower<ISpreadResult>) => {
                    if (res.returnCode !== 0) {
                        this.rc = res.returnCode;
                        this.showLoader.emit(false);
                    }
                })
            );
    }

    getSymbol(id: any): string {
        if (id === 'ILS' || Number(id) === 0 || Number(id) === 376) {
            return '₪';
        }
        if (id === 'USD' || Number(id) === 840) {
            return '$';
        }
        if (id === 'EUR' || Number(id) === 978) {
            return '€';
        }
        return ` ${id} `;
    }

    fairCreditData(data: ICreditDataForFairLawSpreadTransactionRequest): Observable<IResponseLower<IFairCreditResult>> {
        this.showLoader.emit(true);

        return this.httpSvc
            .postLower(`${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/fairCreditData`, data)
            .pipe(
                tap((res: IResponseLower<IFairCreditResult>) => {
                    if (res.returnCode === 0) {
                        this.fairCreditResult = res.result;
                    } else {
                        this.rc = 20;
                    }
                })
            );
    }

    executeSpreadTransaction(): Observable<IResponseLower<IExecuteSpreadTransactionResponse>> {
        const data: ExecuteSpreadTransaction = { numOfPayments: this.numOfPayments };
        return this.httpSvc
            .postLower<IExecuteSpreadTransactionResponse>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/executeSpreadTransaction`,
                data
            )
            .pipe(
                tap(x => {
                    if (x.returnCode === 0) {
                        if (this.uiHelper.isBrowser) {
                            localStorage.setItem('refreshTransaction', '1');
                        }
                        this.otherTransaction = x.result.otherTransactions;
                        this.crmId = x.result.crmId;
                        this.fundReturnDate = x.result.fundReturnDate;
                        this.isExecuteWithMahatz = x.result.isMahatz;
                        this.recommendationId = x.result.recommendationId;
                    } else {
                        this.rc = x.returnCode;
                    }
                })
            );
    }
    CheckSpreadTransactionDGG(request: TransactionT): Observable<IResponseLower<any>> {
        return this.httpSvc
            .postLower(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/CheckSpreadTransactionDGG`,
                request
            )
            .pipe(
                tap(res => {
                    if (res.returnCode !== 0) {
                        this.rc = res.returnCode;
                    }
                })
            );
    }

    checkCreditDataLawAgreements(numOfPayments: number): Observable<IResponseLower<IRegisterCreditProductsResult>> {
        return this.httpSvc
            .postLower<(IRegisterCreditProductsResult)>(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/checkCreditDataLawAgreements`, { numOfPayments }
            )
            .pipe(
                tap(res => {
                    if (res.returnCode !== 0) {
                        this.rc = res.returnCode;
                    } else if ( res.returnCode === 0) {
                        this.registerCreditProductsResult = res.result;
                    }
                })
            );
    }

    InsertNewAgreement(insertAgreementRequest: ISpreadTransactionInsertNewAgreementRequest): Observable<IResponseLower<any>> {
        this.showLoader.emit(true);
        return this.httpSvc
            .postLower(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/insertNewAgreement`,
                insertAgreementRequest
            )
            .pipe(
                tap(_ => {
                    this.showLoader.emit(false);
                })
            );
    }

    checkMahazWithBdi(): Observable<IResponseLower<any>> {
        this.showLoader.emit(true);
        return this.httpSvc
            .postLower(
                `${this.appConfigsService.appConfigs.apiUrl}/registered/spreadTransaction/checkMahazBdi`,
                { numOfPayments: this.numOfPayments}
            )
            .pipe(
                tap(_ => {
                    this.showLoader.emit(false);
                })
            );
    }
}
